export default __webpack_public_path__ + "static/media/eth.b896df07.svg";